
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AddHeader from '../components/AddHeader/AddHeader';
import FormContainer from '../components/FormContainer/FormContainer';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchCategories, updateCategory } from '../hooks/categories';

function EditCategory() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
        const {list:categories } = useSelector((state) => state.categories);
  const { currentLocal } = useSelector((state) => state.currentLocal);

  const categoriesData = categories?.find((item) => item?.id == id)
  const [loading, setLoading] = useState(false)
    const [image, setImage] = useState(null);
      const [ar_categoryName, setar_categoryName] = useState('')
      const [en_categoryName, seten_categoryName] = useState('')
    
  const [imagePreview, setImagePreview] = useState(null);


    const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setImage(file);
  setImagePreview(URL.createObjectURL(file));
};
console.log(categoriesData);

  useEffect(() => {


    setar_categoryName(categoriesData?.name_ar)
    seten_categoryName(categoriesData?.name_en)
    setImagePreview(categoriesData?.image)


  }, [])
  const inputs = [
    { id: 0, name: currentLocal.home.namePlaceholder+" "+currentLocal.home.inEN, value: en_categoryName, onChanegFunction: (e) => seten_categoryName(e.target.value), grid: 6 },
    { id: 1, name:  currentLocal.home.namePlaceholder+" "+currentLocal.home.inAR, value: ar_categoryName, onChanegFunction: (e) => setar_categoryName(e.target.value), grid: 6 },
    { id: 3, name: currentLocal.home.image, onChanegFunction: handleImageChange, grid: 6 ,type: "file"},

  ]

  const handleSubmit = () => {
                  const formData = new FormData();
                  formData.append('name_ar', ar_categoryName)
                  formData.append('name_en', en_categoryName)
                  formData.append('description', "description")
  if (image) {
    formData.append("image", image);
  }
       setLoading(true)

dispatch(updateCategory({ id, data: formData }))
      .unwrap()
      .then(() => {
        setLoading(false)
        dispatch(fetchCategories())
        alert(currentLocal.home.edidedsuccessfully)
        navigate("/dashboard/categories")

      })
      .catch((err) => {
        setLoading(false)

      });
  }
  return (
    <div className='outlit_bg'>
      <AddHeader
        title={currentLocal.home.editcategory}
      />
      <div className='body_container mx-4'  >
        <p className='border-bottom pb-3'>{currentLocal.home.editcategory}</p>
        <FormContainer
          inputs={inputs}
          btnText={currentLocal.home.Save}
          handleSubmit={handleSubmit}
          loading={loading}
          imagePreview={imagePreview}

        />
      </div>
    </div>
  )
}

export default EditCategory
